import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=724b0ee4"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=724b0ee4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports